import React from "react";
import { Col, Modal, Radio, Row } from "antd";
import style from "../../index.module.scss";
import OverflowWrapper from "../../../OverflowWrapper";
import { useAtomValue } from "jotai";
import { typesAtom } from "service/stores/Question/QuestionTypes";
import { toNumber } from "../../../../../../../../service/service";
import { RadioChangeEvent } from "antd/lib/radio/interface";
import { FormInstance } from "rc-field-form";
import fieldStyle from "./index.module.scss";

interface FieldTypesProps {
    value: number;
    onChange: (value: number) => void;
    types: number[];
    disabled: boolean;
    showManage: boolean;
    form: FormInstance;
}

export default function FieldTypes({
    types,
    value: queTypeId,
    onChange: setQueTypeId,
    disabled,
    showManage,
    form
}: FieldTypesProps) {
    const topicTypes = useAtomValue(typesAtom);

    function getTypeName(typeId: number) {
        return topicTypes.find(item => toNumber(item.id) === typeId)
            ?.description;
    }

    function onChange(e: RadioChangeEvent) {
        if (!form.isFieldsTouched()) {
            setQueTypeId(e.target.value);
            return;
        }

        Modal.confirm({
            content: "切换题型后本题填写内容将不会保存，是否放弃本题的填写？",
            onOk: () => setQueTypeId(e.target.value),
            okText: "确认"
        });
    }

    return (
        <Row gutter={[0, 20]}>
            <Col span={4} className={style.label}>
                题型
            </Col>

            <Col span={18} offset={1}>
                <OverflowWrapper
                    width={551}
                    depth={2}
                    className={style.overflowWrapper}>
                    <Radio.Group
                        value={queTypeId}
                        onChange={onChange}
                        disabled={disabled}>
                        {types.map(typeId => (
                            <Radio.Button
                                className={fieldStyle.tab}
                                key={typeId}
                                value={typeId}>
                                <span title={getTypeName(typeId)}>
                                    {getTypeName(typeId)}
                                </span>
                            </Radio.Button>
                        ))}
                    </Radio.Group>
                </OverflowWrapper>
            </Col>
        </Row>
    );
}
